import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'semantic-ui-react'

class SearchField extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      value: props.value || ''
    }

    // Bind events
    this.onChangeInput = this.onChangeInput.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    // When value changes, trigger onChange on parent
    if (prevState.value !== this.state.value) {
      if (_.isFunction(this.props.onChange)) {
        this.props.onChange(this.state.value)
      }
    }

    // When value is changed by parent, update locally
    if (prevProps.value !== this.props.value) {
      this.setState({
        value: this.props.value
      })
    }
  }

  onChangeInput(event, data) {
    const value = data.value
    this.setState({
      value
    })
  }

  render() {
    return (
      <Input
        icon='search'
        placeholder='Chercher...'
        fluid={true}
        value={this.state.value}
        onChange={this.onChangeInput}
      />
    )
  }
}

SearchField.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string
}

export default SearchField



// WEBPACK FOOTER //
// ./src/components/elements/SearchField.js